// The root route: a Fitness account manager lands on their dashboard, everyone
// else keeps today's home. One rule (homePathFor), so sign-in and "/" agree.

import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '../auth';
import { homePathFor } from '../../lib/amDashboard/home';

export function RoleHome({ children }: { children: React.ReactNode }): React.JSX.Element {
  const user = useCurrentUser();
  const path = homePathFor(user);
  return path === '/' ? <>{children}</> : <Navigate to={path} replace />;
}
